import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  NgbModal,
  NgbPopover,
  NgbPopoverConfig
} from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService, CmsService, OccEndpointsService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from 'src/app/shared/utils/common.utils';
import * as constants from '../constants';
import { ReturnService } from '../return.service';
// import * as html2pdf from 'html2pdf.js'

interface PastReturnsResponse {
  dateCreated: string;
  returnNo: string;
  status: string;
  creditNo?: string;
  encryptedCreditNo?: string;
  creditDate?: string;
  creditIssued?: string;
  noOfShippingBoxes: number;
  raLabels: string;
  returnDataList: []
}

@Component({
  selector: 'app-return-history',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './return-history.component.html',
  styleUrls: ['./return-history.component.scss'],
})
export class ReturnHistoryComponent implements OnInit, OnDestroy {
  constantsValue = constants;
  baseUrl: any;
  @ViewChild('t1') public tooltip1: NgbPopover;
  @ViewChild('p1') public actionsPopup: NgbPopover;
  showToolTip1: boolean = false;
  pastReturnsArr: PastReturnsResponse[] = [];
  isLoadingDone = false;
  temppastReturnsArr: PastReturnsResponse[] = [];
  totalReturns = 0;
  curPage = 0;
  pageSize = 18;
  trimStart: number = 0;
  trimEnd: number = 18;
  paginationData = {};
  pageRange: any;
  end: number;
  openedRow: PastReturnsResponse;
  currentActionRow: PastReturnsResponse;
  downloadRAUrl: any;
  pdfUrl: any;
  timeOut: any;
  shippingBoxCount: string = '0';

  tooltipContent: string = `<p>para1</p>
                          <p>para2</p>`;
  returnsSub: Subscription;
  userSub: Subscription;
  downloadReturnSub: Subscription;
  returnInfoSub: Subscription;
  baseSiteId = '';
  userDetails: any;
  userInfo: any;
  locationListSub: Subscription;
  selectedLocations = [];
  returnStatusSub: Subscription;
  returnInformation: any;
  totalBoxes = '';
  page = 1;
  userAccountSub: Subscription;
  LoggedUserAccountSub: Subscription;
  totalPages = 0;
  billingDisplay = false;

  constructor(
    private readonly returnService: ReturnService,
    private readonly modalService: NgbModal,
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly occEndPoint: OccEndpointsService,
    private readonly elementRef: ElementRef,
    private readonly config: NgbPopoverConfig,
    private baseSiteService: BaseSiteService,
    private locStripService: LoactionStripService,
    private readonly cmsData: CmsService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly route: RoutingService,
    private readonly sharedService: SharedService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    config.autoClose = 'outside';
    config.openDelay = 5;
  }

  ngOnInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.locationListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
      this.selectedLocations = locsData;
    });
    this.userSub = this.user.get().subscribe((res) => {
      if (res) {
        this.userDetails = res;
        this.getPastReturns();
        this.pfService.getUserAccountDetailsDataFromDb(this.userDetails.userName,
          this.sharedService.getLocalStorage('accountId'));
        this.userAccountSub = this.pfService.userAccountDetails.subscribe((data) => {
          if (data) {
            this.userInfo = data.res;
            // this.billingDisplay = data.res.billingDisplay;
            this.cd.detectChanges();
          }
        });
        this.LoggedUserAccountSub = this.pfService._userAccountData.subscribe((userData) => {
          if (userData) {
            this.billingDisplay = userData?.defaultB2BUnit?.billingDisplay;
            this.cd.detectChanges();
          }
        })
      }
    });
    //this.pdfUrl = this.baseUrl;
    this.isLoadingDone = true;
    this.cmsData.getComponentData("pdfReservationGuideComponent").subscribe(res => {
      let termCondition: any = JSON.parse(JSON.stringify(res));
      this.pdfUrl = this.baseUrl + termCondition?.document?.url;
    })
    this.cd.detectChanges();

    this.returnService.emitReturnHistory.subscribe(res => {
      if (res)
        this.getPastReturns();
    })
  }

  OnPrint() {
    window.print();
    //const printContent = this.elementRef.nativeElement.querySelector('.print-modal-content').innerHTML;
    //const embeddedView = this.returnModal.createEmbeddedView(null);
    //const printContent = embeddedView.rootNodes[0].innerHTML;
    //const printContent = this.returnModal.natniveElement.innerHTML;

    // const printContent = this.printModalContent?.nativeElement?.innerHTML;
    // // const originalContent = document.body.innerHTML;
    // // document.body.innerHTML = printContent;
    // // window.print();
    // // document.body.innerHTML = originalContent;
    // //window.print();
    // const printWindow= window.open('','_blank');
    // printWindow.document.write('<html><head><title>Print</title>');
    // printWindow.document.write('<link rel="stylesheet" type="text/css" href=""')
    // printWindow.document.write(printContent);
    // printWindow.document.write('</body></html>');
    // printWindow.document.close();
    // printWindow.print();
    // printWindow.close();
  }

  printReturnInfo(modal) {
    clearTimeout(this.timeOut);
    this.openedRow = this.currentActionRow;
    this.modalService.open(modal);
    this.timeOut = setTimeout(() => {
      window.print();
      this.closePopup();
    }, 700);
  }

  // downloadFile(returnKey) {
  //   this.returnService.downloadReturnInfo(this.userDetails.userName, returnKey).subscribe((res) => {
  //     const file = new Blob([res], { type: 'application/pdf' });
  //     const fileURL = URL.createObjectURL(file);
  //     window.open(fileURL);
  //   });
  // }

  getCurrentPage(type) {
    if (type === 'prev') {
      this.curPage -= 1;
    } else if (type === 'next') {
      this.curPage += 1;
    }
    this.getPastReturns();
    // this.trimStart = (this.curPage - 1) * this.pageSize;
    // this.trimEnd = this.trimStart + this.pageSize;

    // const itemsPerPage = 18;
    // if (itemsPerPage < this.totalReturns) {
    //   this.end = itemsPerPage * this.curPage;
    //   if (this.end > this.totalReturns) {
    //     this.end = this.totalReturns;
    //   }
    // } else {
    //   this.end = this.totalReturns;
    // }
    // this.trimEnd = this.trimStart + this.pageSize;
    // if (this.totalReturns > 0) {
    //   this.pageRange = `${this.trimStart + 1}-${this.end}`;
    // } else {
    //   this.pageRange = `0`;
    // }

    // this.setPagination();
  }

  openReturnHistPopupPrint(row: PastReturnsResponse, modal, isPrintPreview) {
    if (!isPrintPreview) {
      this.openedRow = row;
      this.currentActionRow = row;
    } else {
      this.openedRow = this.currentActionRow;
    }
    // this.returnService.returnInformation(
    //   this.userDetails.userName,
    //   this.openedRow.returnNo
    // );
    // this.returnInfoSub = this.returnService.returnInfo$.subscribe(
    //   (returnInfo) => {
    //     if (returnInfo) {
    //       this.returnInformation = returnInfo;
    //       // this.modalService.open(modal, {
    //       //   windowClass: `${this.baseSiteId}`,
    //       // });
    //     }
    //   }
    // );
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      windowClass: `orderHistoryReturnModal ${this.baseSiteId}`
    });
    if (isPrintPreview) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        window.print();
        this.closePopup();
      }, 700);
    }
  }

  openAddShippingBoxPopup(modal) {
    this.page = 1;
    this.shippingBoxCount = '0';
    this.modalService.open(modal,
      {
        centered: true,
        backdrop: 'static',
        windowClass: this.baseSiteId
      });
  }

  closePopup() {
    this.modalService.dismissAll();
  }
  closePopupAndCallApi() {
    this.modalService.dismissAll();
    this.getPastReturns();
  }
  captureCurrentActionRow(row: PastReturnsResponse) {
    this.currentActionRow = row;
  }

  getPastReturns() {
    let filters = {
      fields: 'DEFAULT',
      b2bUnitIds: !!this.selectedLocations && this.selectedLocations?.map((data) => {
        return data.accountNumber
      }),
      currentPage: this.curPage,
      pageSize: this.pageSize
    };
    this.pastReturnsArr = [];
    this.returnService.getReturnsHistory(this.userDetails.userName, filters)
      //this.returnService.returnsList$
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          this.totalReturns = data?.pagination?.totalResults;
          this.totalPages = data?.pagination?.totalPages;
          this.curPage = data?.pagination?.currentPage;
          data?.returns?.forEach((element) => {
            let list: PastReturnsResponse = {
              dateCreated: '',
              returnNo: '',
              status: '',
              creditNo: '',
              encryptedCreditNo: '',
              creditDate: '',
              creditIssued: '',
              noOfShippingBoxes: 0,
              raLabels: '',
              returnDataList: []
            };
            list.status = element?.statusDisplay === 'issued' ? 'Loading...' : element?.statusDisplay;
            list.dateCreated = element?.returnCreationDate;
            list.returnNo = element?.returnKey;
            list.creditNo = element?.creditIssuedList?.entry ? element?.creditIssuedList?.entry[0]?.key : '';
            //list.creditNo = element?.creditIssuedList ? element?.creditIssuedList?.key : '';
            list.encryptedCreditNo = element.encryptedCreditIssuedList.entry ? element.encryptedCreditIssuedList.entry[0].value : '';
            list.creditDate = element?.creditDateList[0];
            list.creditIssued = element?.creditIssuedList?.entry ? element?.creditIssuedList?.entry[0]?.value : '';
            //list.creditIssued = element?.creditIssuedList ? element?.creditIssuedList?.key : '';
            list.noOfShippingBoxes = element?.noOfBoxes;
            list.raLabels = element?.raLabelUrl;
            //list.returnDataList = element?.returnDatalist;
            element?.returnDatalist.forEach((c) => {
              c['productName'] = c['productName'] + ' (' + c['productCode'] + ')'
            })
            list.returnDataList = element?.returnDatalist
            this.pastReturnsArr.push(list);
            if (element?.statusDisplay === 'issued') {
              this.returnService.getReturnStatus(this.userDetails.userName, element?.returnKey)
                //this.returnStatusSub = this.returnService.returnStatus$
                .subscribe((res) => {
                  if (res) {
                    this.pastReturnsArr.filter(x => x.returnNo === res.returnKey).map(t => {
                      t.status = res.statusDisplay;
                    })
                    //list.status = res.statusDisplay;
                    // list.dateCreated = element?.returnCreationDate;
                    // list.returnNo = element?.returnKey;
                    // //list.creditNo = element?.creditIssuedList?.entry[0]?.key;
                    // list.creditNo = element?.creditIssuedList ? element?.creditIssuedList?.key : '';
                    // list.creditDate = element?.creditDateList[0];
                    // //list.creditIssued = element?.creditIssuedList?.entry[0]?.value;
                    // list.creditIssued = element?.creditIssuedList ? element?.creditIssuedList?.key : '';
                    // list.noOfShippingBoxes = element?.noOfBoxes;
                    // list.raLabels = element?.raLabelUrl;
                    // list.returnDataList = element?.returnDatalist;
                    //if(this.pastReturnsArr.length>0)

                    //let isFound = this.pastReturnsArr.find(x => x.returnNo === list.returnNo);
                    // if (!isFound)
                    // this.pastReturnsArr.push(list);
                    //if (this.pastReturnsArr.length > 0) {
                    //this.trimStart = 0;
                    //this.trimEnd =
                    //this.pastReturnsArr.length <= 18 ? this.pastReturnsArr.length : 18;
                    //this.pageSize = this.trimEnd;
                    //this.curPage = 0;

                    //this.getCurrentPage('next');
                    //}

                    this.cd.detectChanges();
                  }
                })
            }
          });
          this.getPageRange();
          this.returnStatusSub?.unsubscribe();
          this.temppastReturnsArr = this.pastReturnsArr;
          this.cd.detectChanges();
          // this.returnsSub?.unsubscribe();
        }

      });
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }

  sortReturnNoColumn(event, dataList): any {
    CommonUtils.onReturnSortClick(event, dataList); // Column Sorting
  }

  // setPagination() {
  //   this.paginationData['pageRange'] = this.pageRange;
  //   this.paginationData['totalReturns'] = this.totalReturns;
  //   this.paginationData['curPage'] = this.curPage;
  //   this.paginationData['numberOfPages'] = this.numberOfPages();
  //   this.returnService.setPaginationValues(this.paginationData);
  // }

  numberOfPages() {
    if (this.pastReturnsArr && this.totalReturns && this.pageSize > 0) {
      return Math.ceil(this.totalReturns / this.pageSize);
    } else {
      return 1;
    }
  }

  downloadRALabels() {
    window.open(this.downloadRAUrl, '_blank');
  }

  redirectToPaymentPage() {
    this.route.goByUrl('/my-account/invoices');
  }

  // decreaseShippingBox(){
  //   if(+this.shippingBoxCount >0){
  //     this.shippingBoxCount= String(+this.shippingBoxCount - 1);
  //   }
  // }
  // increaseShippingBox(){
  //   if(+this.shippingBoxCount <99){
  //     this.shippingBoxCount= String(+this.shippingBoxCount + 1);
  //   }
  // }
  incDecShippingBoxCount(type: string) {
    if (type === 'plus') {
      if (+this.shippingBoxCount < 99)
        this.shippingBoxCount = String(+this.shippingBoxCount + 1);
    } else if (type === 'minus') {
      if (+this.shippingBoxCount > 0)
        this.shippingBoxCount = String(+this.shippingBoxCount - 1);
    }
  }

  checkshippingBoxQty(type: string) {
    // if(+this.shippingBoxCount <1){
    //   this.shippingBoxCount=1
    // }
    const reg = new RegExp('^[0-9]+$');
    let data = reg.test(this.shippingBoxCount);
    if (type === 'keyup') {
      if (
        this.shippingBoxCount !== '' &&
        this.shippingBoxCount !== null &&
        (+this.shippingBoxCount < 1 || !data)
      )
        this.shippingBoxCount = '1';
    } else if (type === 'blur') {
      if (this.shippingBoxCount == '') {
        this.shippingBoxCount = '1';
      }
    }
  }

  rePrintRALabels() {
    window.open(this.currentActionRow.raLabels, '_blank');
  }

  downloadReturnInfo(isRowSelected: any, returnKey?) {
    this.downloadReturnSub = this.returnService
      .downloadReturnInfo(
        this.userDetails.userName,
        isRowSelected === true ? this.currentActionRow.returnNo : returnKey
      )
      .subscribe((data) => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  ngOnDestroy() {
    this.userSub?.unsubscribe();
    //this.returnsSub?.unsubscribe();
    this.locationListSub.unsubscribe();
    this.returnStatusSub?.unsubscribe();
    this.userAccountSub?.unsubscribe();
    this.downloadReturnSub?.unsubscribe();
    this.LoggedUserAccountSub?.unsubscribe();
  }

  updateShippingBox(boxValue) {
    const param = {
      returnkey: this.currentActionRow?.returnNo,
      addBoxQuantity: this.shippingBoxCount
    }
    this.returnService.updateShippingBox(this.userDetails.userName, param).subscribe((res) => {
      if (res.hasOwnProperty('raLabelUrl')) {
        const splitRALabel = res['raLabelUrl'].split('::');
        this.totalBoxes = String((+boxValue) + (+this.shippingBoxCount));
        this.page = 2;
        this.pastReturnsArr.filter(x => x.returnNo === param.returnkey).map(c => {
          c.noOfShippingBoxes = +this.totalBoxes
        });
        this.downloadRAUrl = splitRALabel[3];
        this.cd.detectChanges();
      }
    })
  }

  validateInput(event) {
    if (event.keyCode === 69) {
      return false;
    }
    else {
      var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
      return new RegExp(reg).test(event.key);
    }
  }

  getPageRange() {

    let trimStart = this.curPage * this.pageSize;
    let trimEnd = this.trimStart + this.pageSize;

    const itemsPerPage = 18;
    if (itemsPerPage < this.totalReturns) {
      this.end = itemsPerPage * (this.curPage + 1);
      if (this.end > this.totalReturns) {
        this.end = this.totalReturns;
      }
    } else {
      this.end = this.totalReturns;
    }
    //this.trimEnd = this.trimStart + this.pageSize;
    if (this.totalReturns > 0) {
      this.pageRange = `${trimStart + 1}-${this.end}`;
    } else {
      this.pageRange = `0`;
    }
    this.cd.detectChanges();
  }

  generateInvoicePDF(invoiceNo) {
    this.returnService.downloadPdf(invoiceNo);
  }
}

